import { defineMessages } from 'react-intl';

export default defineMessages({
    requiresAuthenticationTitle: {
        id: '_.processing_payment.modal.requires_authentication_title',
        defaultMessage: 'A quick security check'
    }
});
